export default __webpack_public_path__ + "static/media/adst_banner_new.8ce824bc.png";